<template>
	<div v-if="isload" class="createorder_rate">
		<el-row style="margin-bottom:105px;">
			<el-col :span="12"><senderaddr ref="senderaddr" title="寄件信息" l_mode="寄件人信息-出口"></senderaddr></el-col>
			<el-col :span="12"><receiveraddr ref="receiveraddr" title="收件信息" l_mode="收件人信息-出口"></receiveraddr></el-col>
			<el-col :span="24">
				<packagelist ref="packagelist" :gridheight="gridheight" title="包裹信息" l_mode="包裹信息-出口" @formScrollTop="formScrollTop"></packagelist>
			</el-col>
		</el-row>
		<el-row v-if="!btnhidden" class="footerhandler">
			<el-col :span="6" class="submitBtn_switch" style="text-align: right;color: transparent;">
				1
			</el-col>
			<el-col :span="4" class="submitBtn"><div @click="getrate">获取报价</div></el-col>
			<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">取消</div></el-col>
		</el-row>
		<el-dialog :visible.sync="showratewin" title="报价单" width="700px" :close-on-click-modal="false" lock-scroll :append-to-body="true" :show-close="true">
			<tableui
				style="width:100%;margin-top:-10px"
				v-loading="loading"
				ref="ratelist"
				editcell="0"
				class="ratelist"
				:tableData="ratelist"
				:columns="columns"
				@gridhandle="rategridhandle"
				gridheight="300px"
			></tableui>
		</el-dialog>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import senderaddr from '@/components/address/senderaddr_ssq.vue';
import receiveraddr from '@/components/address/receiveraddr_ssq.vue';
import packagelist from '@/components/order/export_package_list.vue';
import printhandler from '@/components/order/printhandler.vue';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		senderaddr,
		receiveraddr,
		packagelist,
		printhandler,
		tableui
	},
	props: {},
	data() {
		return {
			syscol: '',
			gridheight: '180px',
			orderinfo: {},
			p_pkval:'',
			// pkval:'',
			iscopy: 0,
			btnhidden: false,
			sendremind: false,
			isload: false,
			checkedpmode: '',
			t_id: '',
			wintips: false,
			divclass:'createorder_rate',
			loading:false,
			showratewin:false,
			ratelist:[],
			columns:[
				{ field: 'servicetype', title: '快递公司', type: 'text', sortable: false },
				{ field: 'amount', title: '价格', type: 'text', sortable: false, align: 'right' },
				{
					field: '',
					title: '操作',
					type: 'template',
					width: '130',
					sortable: false,
					template: [{ type: 'link', title: '创建订单', icon: '', handletype: 'success', event: 'createorder' }]
				}
			]
		};
	},
	methods: {
		init(param) {
			var that = this;
			this.isload = false;
			if (param.checkedpmode != undefined) this.checkedpmode = param.checkedpmode;
			if (param.syscol != undefined) this.syscol = param.syscol;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.t_id != undefined) this.t_id = param.t_id;
			if (this.syscol != '') {
				this.isload = true;
				this.$nextTick(function() {
					that.$refs.senderaddr.init({ syscol: that.syscol, orderinfo: that.orderinfo, isznsplit: true });

					that.$refs.receiveraddr.init({ syscol: that.syscol, orderinfo: that.orderinfo });

					that.$refs.packagelist.init({ syscol: that.syscol, orderinfo: that.orderinfo, iscopy: that.iscopy });
				});
			}
		},
		//获取订单信息
		getorderObj() {
			//debugger
			var that = this;
			var error = '';
			var orderinfo = {
				p_mode: this.checkedpmode
			};
			var sender = '',
				receiver = '',
				orderlist = [];
			var orderinfo = {};
			var setlist = this.$refs.senderaddr._data.setlist;
			if (setlist.length > 0) {
				setlist.forEach(e => {
					if (e.value == undefined) {
						e.value = '';
					}
					if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
						error = '请填写' + that.$refs.senderaddr.title + '-' + e.showname;
						sender = '';
					} else {
						if (error == '') {
							if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!that.$tool.checkidcardformat(e.value)) {
									error = that.$refs.senderaddr.title + '-' + e.showname + '格式不正确';
									sender = '';
								}
							}
						}
					}
					if (error == '') sender += '"' + e.colname + '":"' + e.value + '",';
					else return false;
				});
				if (error == '') {
					if (sender != '') {
						sender = sender.replace(/\n/g, '');
						sender = '{' + sender.substring(0, sender.length - 1) + '}';
						orderinfo.sender = JSON.parse(sender);
					}
				}
			}
			if (error == '') {
				setlist = this.$refs.receiveraddr._data.setlist;
				if (setlist.length > 0) {
					setlist.forEach(e => {
						if (e.value == undefined) {
							e.value = '';
						}
						if (e.isnull == 'False' && e.value == '' && e.ishidden == 'False') {
							error = '请填写' + that.$refs.receiveraddr.title + '-' + e.showname;
							receiver = '';
						}
						if (error == '') {
							if (e.coltype == 'idcard' && e.isnull == 'False' && e.ishidden == 'False') {
								if (!that.$tool.checkidcardformat(e.value)) {
									error = that.$refs.receiveraddr.title + '-' + e.showname + '格式不正确';
									receiver = '';
								}
							}
						}
						if (error == '') receiver += '"' + e.colname + '":"' + e.value + '",';
						else return false;
					});
					if (receiver != '') {
						receiver = receiver.replace(/\n/g, '');
						receiver = '{' + receiver.substring(0, receiver.length - 1) + '}';
						orderinfo.receiver = JSON.parse(receiver);
					}
				}
			}
			if (error == '') {
				var pageset = this.$refs.packagelist._data.pageset;
				var cargorow = this.$refs.packagelist._data.columns;
				var index = 0;
				var list = [],
					cargolist = [];
				var baginfo = '';
				pageset.forEach(e => {
					index++;
					baginfo = '';
					cargolist = [];
					e.setlist.forEach(b => {
						if (b.value == undefined) {
							b.value = '';
						}
						if (b.controltype == 'combox-input' && b.ishidden == 'False') {
							var volume = b.combox;
							for (var k = 0; k < volume.length; k++) {
								if (volume[k].value == undefined) {
									volume[k].value = '';
								}
								if (volume[k].isnull == 'False' && volume[k].value == '') {
									error = '请填写第' + index + '个包裹的' + volume[k].showname;
									break;
								}
								baginfo += '"' + volume[k].colname + '":"' + volume[k].value + '",';
							}
						} else if (b.controltype == 'table' && b.ishidden == 'False') {
							if (b.isnull == 'False') {
								if (b.cargolist.length > 0) {
									var cargoindex = 0;
									b.cargolist.forEach(cargo => {
										cargoindex++;
										for (var col in cargo) {
											cargorow.forEach(c => {
												if (col == c.field) {
													if (c.isnull == 'False' && c.colshow == '1') {
														if (cargo[col] == '') error = '第' + index + '个包裹的【第' + cargoindex + '行】' + c.title + '为空';
													}
													return false;
												}
												if (error != '') return false;
											});
											if (error != '') return false;
										}
										if (error != '') return false;
									});
								} else error = '请填写第' + index + '个包裹的' + b.showname;
							}
							if (error == ''){
								cargolist = b.cargolist;
							}	
						} else if (b.ishidden == 'False') {
							if (b.isnull == 'False' && b.value == '') error = '请填写第' + index + '个包裹的' + b.showname;
							else baginfo += '"' + b.colname + '":"' + b.value + '",';
						}
					});
					if (error != '') {
						list = [];
						return false;
					} else {
						if (baginfo != '') {
							baginfo = baginfo.replace(/\n/g, '');
							baginfo = '{' + baginfo.substring(0, baginfo.length - 1) + '}';
						} else {
							baginfo = '{}';
						}
						list.push({ idx: index, baginfo: JSON.parse(baginfo), cargolist: JSON.parse(JSON.stringify(cargolist)) });
					}
				});
				orderinfo.list = list;
			}
			if (error != '') {
				this.$tool.message(error, 0);
				orderinfo = '';
				return false;
			}
			return orderinfo;
		},
		//保存订单
		getrate() {
			var that = this;
			//debugger
			var orderinfo = this.getorderObj();
			if (orderinfo != '') {
				orderinfo.u_userid = localStorage.getItem('userid');
				orderinfo.p_mode = this.checkedpmode;
				orderinfo.t_id = this.t_id;
				console.log('报价',JSON.stringify(orderinfo));
				this.$tool.loading('正在获取报价', this.divclass);
				this.$apipost.post.GetOrderFeeList({ paraminfo:JSON.stringify(orderinfo)  }).then(res => {
					this.$tool.loadingclose();
					if (res.state == '1') {
						that.showratewin=true;
						that.ratelist=res.list;
					} else that.$tool.message(res.message, 0);
				});
			}
		},
		cancel() {
			this.$emit('cancel');
		},
		formScrollTop() {
			this.$emit('formScrollTop');
		},
		rategridhandle(e) {
			var that = this;
			if (e.event == 'createorder') {
				//弹出确定框
				that.p_mode = e.row.p_mode;
				var orderinfo = that.getorderObj();
				if (orderinfo != '') {
					orderinfo.u_userid = localStorage.getItem('userid');
					orderinfo.p_mode = e.row.p_mode;
					this.transUrl(orderinfo);
				}		
			}
		},
		transUrl(orderinfo){
			var l_id='38';
			var that=this;
			this.$tool.loading('正在跳转', this.divclass);
			this.$apipost.get.GetLinkInfo({ l_id: l_id }).then(res => {
				this.$tool.loadingclose();
				that.showratewin=false;
				if (res.info !=undefined) {
					Utils.$emit('go', { l_url: '/packagemanange/createorder_pkg',l_id:l_id, l_name: res.info.l_name, urlparam: {orderinfo:orderinfo,l_tablename:res.info.l_tablename} });
				} else that.$tool.message('', 0);
			});
		}
	}
};
</script>

<style></style>
